"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.extraConfig = exports.appBaseURLs = exports.projectName = void 0;
/*
Environment is obtained from a file __ENV.js which is generated by
'@beam-australia/react-env'.
The __ENV.js file is deployed as part of a deployment. This enables
builds to be environment independent. A environment specific
__ENV.js is deployed for each deployment.

To obtain environment configuration use the `env` object exposed
by '@beam-australia/react-env'.
 */
const react_env_1 = __importDefault(require("@beam-australia/react-env"));
const env = react_env_1.default;
exports.projectName = (_a = env('PROJECT_NAME')) !== null && _a !== void 0 ? _a : '-';
const urlSuffix = exports.projectName === 'live' ? '' : `-${exports.projectName}`;
const domainSuffix = exports.projectName === 'live' ? '' : `${exports.projectName}.`;
const projectId = `upflowy-${exports.projectName}`;
function organisationStorage(name) {
    const defaultOrganisationStorage = `https://firebasestorage.googleapis.com/v0/b/${projectId}.appspot.com/o/`;
    return `${env('UPFLOWY_PUBLIC_STORAGE_URL')
        ? env('UPFLOWY_PUBLIC_STORAGE_URL').replace('public', '')
        : defaultOrganisationStorage}${name.replace(/\//g, '%2F')}?alt=media`;
}
exports.appBaseURLs = env('ENV') === 'local'
    ? {
        domain: (_b = env('APPLICATION_DOMAIN')) !== null && _b !== void 0 ? _b : 'localhost',
        client: (_c = env('UPFLOWY_CLIENT_URL')) !== null && _c !== void 0 ? _c : 'http://localhost:3030',
        consumer: (_d = env('UPFLOWY_CONSUMER_URL')) !== null && _d !== void 0 ? _d : 'http://localhost:3020',
        consumerDomain: (_e = env('UPFLOWY_CONSUMER_DOMAIN')) !== null && _e !== void 0 ? _e : 'localhost:3020',
        admin: (_f = env('UPFLOWY_ADMIN_URL')) !== null && _f !== void 0 ? _f : 'http://localhost:3010',
        playground: (_g = env('UPFLOWY_PLAYGROUND_URL')) !== null && _g !== void 0 ? _g : 'http://localhost:3030',
        api: (_h = env('UPFLOWY_API_URL')) !== null && _h !== void 0 ? _h : `http://localhost:5001/upflowy-${exports.projectName}/us-central1`,
        libs: (_j = env('UPFLOWY_LIBS_URL')) !== null && _j !== void 0 ? _j : `${(_k = env('UPFLOWY_CONSUMER_URL')) !== null && _k !== void 0 ? _k : 'http://localhost:3020'}/lib`,
        publicStorage(name) {
            var _a;
            return `${(_a = env('UPFLOWY_PUBLIC_STORAGE_URL')) !== null && _a !== void 0 ? _a : 'http://localhost:3040'}/${name}`;
        },
        organisationStorage,
    }
    : {
        domain: (_l = env('APPLICATION_DOMAIN')) !== null && _l !== void 0 ? _l : 'web.app',
        client: (_m = env('UPFLOWY_CLIENT_URL')) !== null && _m !== void 0 ? _m : `https://sdk${urlSuffix}.upflowy.com`,
        consumer: (_o = env('UPFLOWY_CONSUMER_URL')) !== null && _o !== void 0 ? _o : `https://my${urlSuffix}.upflowy.com`,
        consumerDomain: `${domainSuffix}${(_p = env('UPFLOWY_CONSUMER_DOMAIN')) !== null && _p !== void 0 ? _p : 'upflowy.co'}`,
        admin: (_q = env('UPFLOWY_ADMIN_URL')) !== null && _q !== void 0 ? _q : `https://app${urlSuffix}.upflowy.com`,
        playground: (_r = env('UPFLOWY_PLAYGROUND_URL')) !== null && _r !== void 0 ? _r : `https://playground${urlSuffix}.upflowy.com`,
        libs: (_s = env('UPFLOWY_LIBS_URL')) !== null && _s !== void 0 ? _s : `${`https://my${urlSuffix}.upflowy.com`}/lib`,
        api: (_t = env('UPFLOWY_API_URL')) !== null && _t !== void 0 ? _t : `https://us-central1-upflowy-${exports.projectName}.cloudfunctions.net`,
        publicStorage(name) {
            var _a;
            const defaultPublicStorage = `https://firebasestorage.googleapis.com/v0/b/${projectId}.appspot.com/o/public`;
            // Note firestore requires paths to have %2F as '/'
            return `${(_a = env('UPFLOWY_PUBLIC_STORAGE_URL')) !== null && _a !== void 0 ? _a : defaultPublicStorage}%2F${name.replace(/\//g, '%2F')}?alt=media`;
        },
        organisationStorage,
        cdnPath: `https://storage.googleapis.com/${projectId}.appspot.com`,
    };
const toNumberOrUndefined = (numStr) => (numStr ? Number(numStr) : undefined);
const config = {
    env: (_u = env('ENV')) !== null && _u !== void 0 ? _u : 'dev',
    apiKey: (_v = env('FIRESTORE_API_KEY')) !== null && _v !== void 0 ? _v : '-',
    authDomain: (_w = env('GCLOUD_AUTH_DOMAIN')) !== null && _w !== void 0 ? _w : `app${urlSuffix}.upflowy.com`,
    databaseURL: (_x = env('FIREBASE_URL')) !== null && _x !== void 0 ? _x : `https://upflowy-${exports.projectName}.firebaseio.com`,
    projectId,
    storageBucket: (_y = env('FIREBASE_STORAGE_BUCKET')) !== null && _y !== void 0 ? _y : `upflowy-${exports.projectName}.appspot.com`,
    messagingSenderId: (_z = env('MESSAGING_SENDER_ID')) !== null && _z !== void 0 ? _z : '-',
    appId: (_0 = env('APP_ID')) !== null && _0 !== void 0 ? _0 : '-',
    measurementId: (_1 = env('MEASUREMENT_ID')) !== null && _1 !== void 0 ? _1 : '-',
    experimentalAutoDetectLongPolling: !!env('FIRESTORE_AUTO_DETECT_LONG_POLLING'),
};
exports.extraConfig = {
    experimentalForceLongPolling: !!env('FIRESTORE_LONG_POLLING'),
    emulation: {
        functions: !!env('EMULATION_FUNCTIONS'),
        functionsHost: env('EMULATION_FUNCTIONS_HOST'),
        functionsPort: toNumberOrUndefined(env('EMULATION_FUNCTIONS_PORT')),
        auth: !!env('EMULATION_AUTH'),
        authUrl: env('EMULATION_AUTH_URL'),
        firestore: !!env('EMULATION_FIRESTORE'),
        firestoreHost: env('EMULATION_FIRESTORE_HOST'),
        firestorePort: toNumberOrUndefined(env('EMULATION_FIRESTORE_PORT')),
        storageBucket: !!env('EMULATION_FIRESTORE'),
    },
};
exports.default = config;
//# sourceMappingURL=index.js.map